<template>
    <section class='viewsrhqyBaseManage_index space-y-1'>
        <viewTitle title="业务管理 / 基础数据管理 / 基地管理" :showReturn="false" />
        <el-button @click="onAdd" size="medium" type="primary">添加</el-button>
        <el-form ref="form" :model="queryParam" inline>
            <el-form-item label="基地名称：">
                <el-input v-model="queryParam.baseName" placeholder="请输入基地名称" class="w-60"></el-input>
            </el-form-item>
        </el-form>
        <c-table id="baseManage" :isIndex="false" :data="dataSource" :columns="columns" :query.sync="pagintion"
            :total="total" @loadPage="loadData">
            <template slot="type" slot-scope="scope">
                <dict-text dictType="bid_base_type" :value="scope.row.type"></dict-text>
            </template>
            <template slot="action" slot-scope="scope">
                <el-row type="flex" justify="space-around" align="middle">
                    <c-link @click="onEdit(scope.row)"
                        label="修改"></c-link>
                    <c-link @click="onDelete(scope.row)" label="删除"
                        type="danger"></c-link>
                    <c-link v-if="scope.row.state == 2" @click="onStart(scope.row)"
                        label="启用" type="success"></c-link>
                    <c-link v-if="scope.row.state == 1" @click="onStop(scope.row)"
                        label="禁用" type="warning"></c-link>
                </el-row>
            </template>
        </c-table>
        <base-modal ref="baseModal"></base-modal>
    </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import baseModal from './components/baseModal.vue';
export default {
    data() {
        return {
            total: 0,
            tableData: [],
            columns: [
                { label: '排序', prop: 'idx', width: 80 },
                { label: '基地名称', prop: 'name' },
                { label: '基地编码', prop: 'code', width: 200 },
                {
                    label: '状态',
                    prop: 'state',
                    formatData(row) {
                        return row.state == 1 ? '启用' : '禁用';
                    },
                    width: 200
                },
                {
                    label: '创建时间',
                    prop: 'create_time',
                    width: 200
                },
                {
                    label: '操作',
                    prop: 'action',
                    width: 200
                }
            ],
            selection: [],
            fetchDataEvent: (params) => this.$common.http({
                url: "/api/contact/list_base",
                data: params,
            })
        };
    },
    components: {
        baseModal
    },
    mixins: [initListMinxin, mixinTableLyout],
    methods: {
        onAdd() {
            this.$refs.baseModal.openModal();
        },
        onEdit() {},
        onDelete() {},
        onStart() {},
        onStop() {},
    }
}

</script>